<template>
  <section :id="data.id" class="cta-section-with-background">
    <div class="container grid max-w-none grid-cols-12">
      <div class="cta-section-with-background__background">
        <CdnImg
          v-if="banner"
          :src="banner"
          alt=""
          :width="mdAndUp ? 1824 : 327"
          :height="mdAndUp ? 240 : 280"
          class="absolute left-0 top-0 h-full w-full rounded-lg object-cover"
          loading="lazy"
        />
      </div>
      <div
        class="align-center relative col-span-full row-start-1 flex items-center justify-center text-white sm:col-start-3 sm:col-end-11"
      >
        <div class="cta-section-with-background__content">
          <UiSectionTitle
            class="title mb-2 text-xl uppercase sm:mb-4 sm:text-3xl"
            :title="data.title"
          />
          <div
            v-if="data.description"
            class="cta-section-with-background__description"
            v-html="data.description"
          />
          <div v-if="data.link" class="mt-4 sm:mt-6">
            <UiButton
              v-if="data.link.src"
              :to="data.link.src"
              :size="mdAndUp ? 'md' : undefined"
              inverted
            >
              <span v-html="data.link.text" />
            </UiButton>
            <UiButton v-else :size="mdAndUp ? 'md' : undefined" inverted>
              <span v-html="data.link.text" />
            </UiButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import UiSectionTitle from '~/components/ui/UiSectionTitle.vue';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isBiggerThanBreakpoint: mdAndUp } = useBreakpoint('md');
const banner = computed(() => {
  let image = props.data.banner?.src;
  if (!image) return undefined;

  if (!mdAndUp.value) {
    image =
      props.data.banner.mobile && props.data.banner.mobile.src
        ? props.data.banner.mobile.src
        : props.data.banner.src;
  }
  return image;
});
</script>

<style lang="scss" scoped>
.cta-section-with-background {
  margin: 40px 0;
  @media screen and (min-width: 768px) {
    margin: 56px 0;
  }
  &__background {
    position: relative;
    grid-column: 1/-1;
    grid-row-start: 1;
    &::before {
      content: '';
      padding-top: calc(280 / 327 * 100%);
      display: block;
      width: 100%;
      @media screen and (min-width: 768px) {
        padding-top: calc(240 / 1344 * 100%);
      }
      @media screen and (min-width: 1440px) {
        padding-top: 240px;
      }
    }
  }
  &__description {
    font-size: 12px;
    @media screen and (min-width: 768px) {
      font-size: 18px;
      line-height: 1.2;
    }
  }
  &__content {
    text-align: center;
    padding: 24px;
  }
}
</style>
